import axios from '@/lib/axios';
import { FixedAsset, Product, PurchaseOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0561. 発注案件アーカイブ解除
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:id/unarchive
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const unarchivePurchaseOrder = (props: Props): Promise<PurchaseOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/unarchive`, props);
};

export const useUnarchivePurchaseOrder = () => {
  return useMutation({
    mutationFn: unarchivePurchaseOrder,
  });
};
